export const PAGETYPE_ROOT = 'index';
export const PAGETYPE_PRODUCT = 'product';
export const PAGETYPE_CATEGORY = 'category';
export const PAGETYPE_KEYWORD = 'kwlp';
export const PAGETYPE_CAMPAIGN = 'campaign';
export const PAGETYPE_STORE = 'shop';
export const PAGETYPE_BRAND = 'manufacturer';
export const PAGETYPE_OTHER = 'other';

export const pageTypeIsRoot = pageType => pageType === PAGETYPE_ROOT;

// "Schibstedt page types"
export const SCH_PAGETYPE_ARTICLE = 'article';
export const SCH_PAGETYPE_FRONT = 'front';
export const SCH_PAGETYPE_MYPAGES = 'mypages';
export const SCH_PAGETYPE_OBJECT = 'object';
export const SCH_PAGETYPE_OTHER = 'other';
export const SCH_PAGETYPE_RESULT = 'result';
export const SCH_PAGETYPE_SECTION = 'section';

export default {
  PAGETYPE_ROOT,
  PAGETYPE_PRODUCT,
  PAGETYPE_CATEGORY,
  PAGETYPE_CAMPAIGN,
  PAGETYPE_STORE,
  PAGETYPE_BRAND,
  PAGETYPE_OTHER,
  pageTypeIsRoot,
};
